// Stable capabilities, independent of labels, Identity role names and group IDs.
export const PRODUCER_MENU = [
  { name: 'BusquedaCartera', path: '/cartera', permission: 'portfolio.read' },
  { name: 'LibreDeuda', path: '/libredeuda', permission: 'portfolio.debtfree.read' },
  { name: 'ComisionesPendientes', path: '/comisiones-pendientes', permission: 'settlements.commissions.read' },
  { name: 'PagosYLiquidaciones', path: '/liquidaciones-facturas-pendientes', permission: 'settlements.pending.read' },
  { name: 'PagosYRetenciones', path: '/pagos-retenciones', permission: 'settlements.payments.read' },
  { name: 'ConceptosFacturar', path: '/conceptos-a-facturar', permission: 'settlements.concepts.read' },
  { name: 'EnvioFacturas', path: '/consulta?data=envioFactura', permission: 'invoices.submit' },
  { name: 'RechazoMotivo', path: '/rechazos', permission: 'rejections.read' },
  { name: 'DeudoresPremio', path: '/deudores', permission: 'debtors.read' },
  { name: 'DeudasYPagos', path: '/deudas-y-pagos', permission: 'collections.portal.access' },
  { name: 'Siniestros', path: '/listar-siniestros', permission: 'claims.read' },
  { name: 'Consultas', path: '/consulta', permission: 'requests.create' },
  { name: 'Tutoriales', path: '/tutoriales', permission: 'resources.read' },
  { name: 'URLBrokers', permission: 'brokers.access' },
  { name: 'URLCanales', permission: 'channels.access' }
];

export const PRODUCER_ACTION_PERMISSIONS = [
  'portfolio.export', 'debtors.export', 'rejections.export',
  ...['commissions', 'pending', 'payments', 'concepts'].map(section => `settlements.${section}.export`)
];
